export default {
  box: {
    'maximize': 'Ingrandisci',
    'minimize': 'Rimpicciolisci'
  }
}
